import { useContext } from 'react'
import { NumberOfProcessingImagesContext } from '@/context/NumberOfProcessingImagesContext'

export const useNumberImages = () => {
  const ctx = useContext(NumberOfProcessingImagesContext)
  if (!ctx) throw new Error('useNumberImages must be used within a NumberOfProcessingImagesProvider')
  return ctx
}